// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"21f15405910d413e6bed","111":"c5ec6784240e3f8b1257","112":"c10e4cbef863ed57b7f8","159":"981a30f352558d0b8ec2"}[chunkId] + ".chunk.js";
};